export const TIME_BASED_SELECTION = [
    {label: "Week", value: "WEEK"},
    {label: "15 days", value: "TWO_WEEKS"},
    {label: "1 Month", value: "MONTH"},
    {label: "3 Months", value: "THREE_MONTHS"},
]

export const DASHBOARD_DURATIONS = [
    { label: "This Week", value: "WEEK" },
    { label: "Last 15 days", value: "FIFTEEN_DAYS" },
    { label: "This month", value: "MONTH" },
    { label: "Last 3 Months", value: "THREE_MONTH" },
    { label: "Last 6 Months", value: "SEMESTER" },
    { label: "This Year", value: "YEAR" },
    { label: "Last Year", value: "LAST_YEAR" },
];


export const STATS = {
    "families": 0,
    "males": 3,
    "females": 0,
    "active": 3,
    "inactive": 0,
    "membersInIndia": 3,
    "membersAbroad": 0,
    "admins": 3,
    "usedSms": 0,
    "maxSms": 0,
    "usedEmails": 0,
    "maxEmails": 0,
    "usedWhatsapp": 0,
    "maxWhatsapp": 0,
    "partnerCategoryWiseStats": {
        "5 MINS PRAYER": 0,
        "MINISTRY PARTNER": 0,
        "CHILDREN'S PLAN ": 0,
        "MEDIA PARTNER": 0,
        "COMMUNICATION PARTNER": 0,
        "GIFT A BIBLE": 0,
        "SOCIAL SERVICE": 0,
        "DND": 0,
        "ONE SOUL AT A TIME": 0,
        "FAMILY BLESSING PLAN": 0,
        "SCHOOL OF EVANGELISM": 0,
        "MAGAZINE SUBSCRIBER": 2
    },
    "categoryWiseDonations": {
        "WEEK": {
            "5 MINS PRAYER": 1520,
            "MINISTRY PARTNER": 0,
            "CHILDREN'S PLAN ": 0,
            "MEDIA PARTNER": 0,
            "COMMUNICATION PARTNER": 150,
            "SOCIAL SERVICE": 0,
            "GIFT A BIBLE": 0,
            "DND": 0,
            "ONE SOUL AT A TIME": 0,
            "FAMILY BLESSING PLAN": 0,
            "MAGAZINE SUBSCRIBER": 0,
            "SCHOOL OF EVANGELISM": 0
        },
        "LAST_YEAR": {
            "5 MINS PRAYER": 0,
            "MINISTRY PARTNER": 0,
            "CHILDREN'S PLAN ": 0,
            "MEDIA PARTNER": 0,
            "COMMUNICATION PARTNER": 0,
            "SOCIAL SERVICE": 0,
            "GIFT A BIBLE": 0,
            "DND": 0,
            "ONE SOUL AT A TIME": 0,
            "FAMILY BLESSING PLAN": 0,
            "MAGAZINE SUBSCRIBER": 0,
            "SCHOOL OF EVANGELISM": 0
        },
        "FIFTEEN_DAYS": {
            "5 MINS PRAYER": 1520,
            "MINISTRY PARTNER": 0,
            "CHILDREN'S PLAN ": 0,
            "MEDIA PARTNER": 0,
            "COMMUNICATION PARTNER": 150,
            "SOCIAL SERVICE": 0,
            "GIFT A BIBLE": 150,
            "DND": 0,
            "ONE SOUL AT A TIME": 0,
            "FAMILY BLESSING PLAN": 1520,
            "MAGAZINE SUBSCRIBER": 0,
            "SCHOOL OF EVANGELISM": 0
        },
        "SEMESTER": {
            "5 MINS PRAYER": 1520,
            "MINISTRY PARTNER": 0,
            "CHILDREN'S PLAN ": 0,
            "MEDIA PARTNER": 0,
            "COMMUNICATION PARTNER": 150,
            "SOCIAL SERVICE": 0,
            "GIFT A BIBLE": 150,
            "DND": 0,
            "ONE SOUL AT A TIME": 0,
            "FAMILY BLESSING PLAN": 1520,
            "MAGAZINE SUBSCRIBER": 0,
            "SCHOOL OF EVANGELISM": 0
        },
        "MONTH": {
            "5 MINS PRAYER": 1520,
            "MINISTRY PARTNER": 0,
            "CHILDREN'S PLAN ": 0,
            "MEDIA PARTNER": 0,
            "COMMUNICATION PARTNER": 150,
            "SOCIAL SERVICE": 0,
            "GIFT A BIBLE": 150,
            "DND": 0,
            "ONE SOUL AT A TIME": 0,
            "FAMILY BLESSING PLAN": 0,
            "MAGAZINE SUBSCRIBER": 0,
            "SCHOOL OF EVANGELISM": 0
        },
        "YEAR": {
            "5 MINS PRAYER": 1520,
            "MINISTRY PARTNER": 0,
            "CHILDREN'S PLAN ": 0,
            "MEDIA PARTNER": 0,
            "COMMUNICATION PARTNER": 150,
            "SOCIAL SERVICE": 0,
            "GIFT A BIBLE": 150,
            "DND": 0,
            "ONE SOUL AT A TIME": 0,
            "FAMILY BLESSING PLAN": 1520,
            "MAGAZINE SUBSCRIBER": 0,
            "SCHOOL OF EVANGELISM": 0
        },
        "THREE_MONTH": {
            "5 MINS PRAYER": 1520,
            "MINISTRY PARTNER": 0,
            "CHILDREN'S PLAN ": 0,
            "MEDIA PARTNER": 0,
            "COMMUNICATION PARTNER": 150,
            "SOCIAL SERVICE": 0,
            "GIFT A BIBLE": 150,
            "DND": 0,
            "ONE SOUL AT A TIME": 0,
            "FAMILY BLESSING PLAN": 1520,
            "MAGAZINE SUBSCRIBER": 0,
            "SCHOOL OF EVANGELISM": 0
        }
    },
    "orgRegistrations": {
        "WEEK": {
            "2 Feb": 0,
            "3 Feb": 1,
            "4 Feb": 0,
            "5 Feb": 0,
            "6 Feb": 0,
            "7 Feb": 0,
            "8 Feb": 0,
            "9 Feb": 0
        },
        "FIFTEEN_DAYS": {
            "20 Jan": 0,
            "21 Jan": 0,
            "22 Jan": 0,
            "23 Jan": 0,
            "24 Jan": 0,
            "25 Jan": 0,
            "26 Jan": 0,
            "27 Jan": 0,
            "28 Jan": 0,
            "29 Jan": 2,
            "30 Jan": 0,
            "31 Jan": 0,
            "1 Feb": 0,
            "2 Feb": 0,
            "3 Feb": 1,
            "4 Feb": 0
        },
        "MONTH": {
            "1 Feb": 0,
            "2 Feb": 0,
            "3 Feb": 1,
            "4 Feb": 0,
            "5 Feb": 0,
            "6 Feb": 0,
            "7 Feb": 0,
            "8 Feb": 0,
            "9 Feb": 0,
            "10 Feb": 0,
            "11 Feb": 0,
            "12 Feb": 0,
            "13 Feb": 0,
            "14 Feb": 0,
            "15 Feb": 0,
            "16 Feb": 0,
            "17 Feb": 0,
            "18 Feb": 0,
            "19 Feb": 0,
            "20 Feb": 0,
            "21 Feb": 0,
            "22 Feb": 0,
            "23 Feb": 0,
            "24 Feb": 0,
            "25 Feb": 0,
            "26 Feb": 0,
            "27 Feb": 0,
            "28 Feb": 0
        }
    },
    "institutionWiseTopMembers": {
        "WEEK": [
            {
                "code": "25JL0145",
                "fullName": "adam legend",
                "category": "5 MINS PRAYER",
                "amount": 1520,
                "district": "Tiruchirappalli"
            },
            {
                "code": "25JL0145",
                "fullName": "adam legend",
                "category": "COMMUNICATION PARTNER",
                "amount": 150,
                "district": "Tiruchirappalli"
            }
        ],
        "LAST_YEAR": [
            {
                "code": "25JL0145",
                "fullName": "adam legend",
                "category": "5 MINS PRAYER",
                "amount": 1520,
                "district": "Tiruchirappalli"
            },
            {
                "code": "25JL0145",
                "fullName": "adam legend",
                "category": "FAMILY BLESSING PLAN",
                "amount": 1520,
                "district": "Tiruchirappalli"
            },
            {
                "code": "25JL0145",
                "fullName": "adam legend",
                "category": "GIFT A BIBLE",
                "amount": 150,
                "district": "Tiruchirappalli"
            },
            {
                "code": "25JL0145",
                "fullName": "adam legend",
                "category": "COMMUNICATION PARTNER",
                "amount": 150,
                "district": "Tiruchirappalli"
            }
        ],
        "FIFTEEN_DAYS": [
            {
                "code": "25JL0145",
                "fullName": "adam legend",
                "category": "5 MINS PRAYER",
                "amount": 1520,
                "district": "Tiruchirappalli"
            },
            {
                "code": "25JL0145",
                "fullName": "adam legend",
                "category": "FAMILY BLESSING PLAN",
                "amount": 1520,
                "district": "Tiruchirappalli"
            },
            {
                "code": "25JL0145",
                "fullName": "adam legend",
                "category": "GIFT A BIBLE",
                "amount": 150,
                "district": "Tiruchirappalli"
            },
            {
                "code": "25JL0145",
                "fullName": "adam legend",
                "category": "COMMUNICATION PARTNER",
                "amount": 150,
                "district": "Tiruchirappalli"
            }
        ],
        "SEMESTER": [
            {
                "code": "25JL0145",
                "fullName": "adam legend",
                "category": "5 MINS PRAYER",
                "amount": 1520,
                "district": "Tiruchirappalli"
            },
            {
                "code": "25JL0145",
                "fullName": "adam legend",
                "category": "FAMILY BLESSING PLAN",
                "amount": 1520,
                "district": "Tiruchirappalli"
            },
            {
                "code": "25JL0145",
                "fullName": "adam legend",
                "category": "GIFT A BIBLE",
                "amount": 150,
                "district": "Tiruchirappalli"
            },
            {
                "code": "25JL0145",
                "fullName": "adam legend",
                "category": "COMMUNICATION PARTNER",
                "amount": 150,
                "district": "Tiruchirappalli"
            }
        ],
        "MONTH": [
            {
                "code": "25JL0145",
                "fullName": "adam legend",
                "category": "5 MINS PRAYER",
                "amount": 1520,
                "district": "Tiruchirappalli"
            },
            {
                "code": "25JL0145",
                "fullName": "adam legend",
                "category": "COMMUNICATION PARTNER",
                "amount": 150,
                "district": "Tiruchirappalli"
            },
            {
                "code": "25JL0145",
                "fullName": "adam legend",
                "category": "GIFT A BIBLE",
                "amount": 150,
                "district": "Tiruchirappalli"
            }
        ],
        "YEAR": [
            {
                "code": "25JL0145",
                "fullName": "adam legend",
                "category": "5 MINS PRAYER",
                "amount": 1520,
                "district": "Tiruchirappalli"
            },
            {
                "code": "25JL0145",
                "fullName": "adam legend",
                "category": "FAMILY BLESSING PLAN",
                "amount": 1520,
                "district": "Tiruchirappalli"
            },
            {
                "code": "25JL0145",
                "fullName": "adam legend",
                "category": "GIFT A BIBLE",
                "amount": 150,
                "district": "Tiruchirappalli"
            },
            {
                "code": "25JL0145",
                "fullName": "adam legend",
                "category": "COMMUNICATION PARTNER",
                "amount": 150,
                "district": "Tiruchirappalli"
            }
        ],
        "THREE_MONTH": [
            {
                "code": "25JL0145",
                "fullName": "adam legend",
                "category": "5 MINS PRAYER",
                "amount": 1520,
                "district": "Tiruchirappalli"
            },
            {
                "code": "25JL0145",
                "fullName": "adam legend",
                "category": "FAMILY BLESSING PLAN",
                "amount": 1520,
                "district": "Tiruchirappalli"
            },
            {
                "code": "25JL0145",
                "fullName": "adam legend",
                "category": "GIFT A BIBLE",
                "amount": 150,
                "district": "Tiruchirappalli"
            },
            {
                "code": "25JL0145",
                "fullName": "adam legend",
                "category": "COMMUNICATION PARTNER",
                "amount": 150,
                "district": "Tiruchirappalli"
            }
        ]
    },
    "membersByCategory": {
        "WEEK": {
            "5 MINS PRAYER": 1,
            "MINISTRY PARTNER": 0,
            "CHILDREN'S PLAN ": 0,
            "MEDIA PARTNER": 0,
            "COMMUNICATION PARTNER": 1,
            "SOCIAL SERVICE": 0,
            "GIFT A BIBLE": 1,
            "DND": 0,
            "ONE SOUL AT A TIME": 1,
            "FAMILY BLESSING PLAN": 1,
            "MAGAZINE SUBSCRIBER": 3,
            "SCHOOL OF EVANGELISM": 0
        },
        "LAST_YEAR": {
            "5 MINS PRAYER": 1,
            "MINISTRY PARTNER": 0,
            "CHILDREN'S PLAN ": 0,
            "MEDIA PARTNER": 0,
            "COMMUNICATION PARTNER": 1,
            "SOCIAL SERVICE": 0,
            "GIFT A BIBLE": 1,
            "DND": 0,
            "ONE SOUL AT A TIME": 1,
            "FAMILY BLESSING PLAN": 1,
            "MAGAZINE SUBSCRIBER": 3,
            "SCHOOL OF EVANGELISM": 0
        },
        "FIFTEEN_DAYS": {
            "5 MINS PRAYER": 1,
            "MINISTRY PARTNER": 0,
            "CHILDREN'S PLAN ": 0,
            "MEDIA PARTNER": 0,
            "COMMUNICATION PARTNER": 1,
            "SOCIAL SERVICE": 0,
            "GIFT A BIBLE": 1,
            "DND": 0,
            "ONE SOUL AT A TIME": 1,
            "FAMILY BLESSING PLAN": 1,
            "MAGAZINE SUBSCRIBER": 3,
            "SCHOOL OF EVANGELISM": 0
        },
        "SEMESTER": {
            "5 MINS PRAYER": 1,
            "MINISTRY PARTNER": 0,
            "CHILDREN'S PLAN ": 0,
            "MEDIA PARTNER": 0,
            "COMMUNICATION PARTNER": 1,
            "SOCIAL SERVICE": 0,
            "GIFT A BIBLE": 1,
            "DND": 0,
            "ONE SOUL AT A TIME": 1,
            "FAMILY BLESSING PLAN": 1,
            "MAGAZINE SUBSCRIBER": 3,
            "SCHOOL OF EVANGELISM": 0
        },
        "MONTH": {
            "5 MINS PRAYER": 1,
            "MINISTRY PARTNER": 0,
            "CHILDREN'S PLAN ": 0,
            "MEDIA PARTNER": 0,
            "COMMUNICATION PARTNER": 1,
            "SOCIAL SERVICE": 0,
            "GIFT A BIBLE": 1,
            "DND": 0,
            "ONE SOUL AT A TIME": 1,
            "FAMILY BLESSING PLAN": 1,
            "MAGAZINE SUBSCRIBER": 3,
            "SCHOOL OF EVANGELISM": 0
        },
        "YEAR": {
            "5 MINS PRAYER": 1,
            "MINISTRY PARTNER": 0,
            "CHILDREN'S PLAN ": 0,
            "MEDIA PARTNER": 0,
            "COMMUNICATION PARTNER": 1,
            "SOCIAL SERVICE": 0,
            "GIFT A BIBLE": 1,
            "DND": 0,
            "ONE SOUL AT A TIME": 1,
            "FAMILY BLESSING PLAN": 1,
            "MAGAZINE SUBSCRIBER": 3,
            "SCHOOL OF EVANGELISM": 0
        },
        "THREE_MONTH": {
            "5 MINS PRAYER": 1,
            "MINISTRY PARTNER": 0,
            "CHILDREN'S PLAN ": 0,
            "MEDIA PARTNER": 0,
            "COMMUNICATION PARTNER": 1,
            "SOCIAL SERVICE": 0,
            "GIFT A BIBLE": 1,
            "DND": 0,
            "ONE SOUL AT A TIME": 1,
            "FAMILY BLESSING PLAN": 1,
            "MAGAZINE SUBSCRIBER": 3,
            "SCHOOL OF EVANGELISM": 0
        }
    }
}